var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.2222H8V8.61111H6V15.2222ZM10 15.2222H12V5.77778H10V15.2222ZM14 15.2222H16V11.4444H14V15.2222ZM4 19C3.45 19 2.97917 18.815 2.5875 18.4451C2.19583 18.0752 2 17.6306 2 17.1111V3.88889C2 3.36944 2.19583 2.92477 2.5875 2.55486C2.97917 2.18495 3.45 2 4 2H18C18.55 2 19.0208 2.18495 19.4125 2.55486C19.8042 2.92477 20 3.36944 20 3.88889V17.1111C20 17.6306 19.8042 18.0752 19.4125 18.4451C19.0208 18.815 18.55 19 18 19H4ZM4 17.1111H18V3.88889H4V17.1111Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsIcon);
export default __webpack_public_path__ + "static/media/metrics_icon.21469adfbe047cf8006c1801121226e7.svg";
export { ForwardRef as ReactComponent };